import { useEffect } from 'react';

const usePageTitle = (title?: string) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);
};

export default usePageTitle;
